import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import { Roles } from "./roles";
import AppLogout from "../../utilities/AppLogout"

const Routes_En = () => {
  const Home = lazy(() => import("../../components/home/Home"));
  // const Dashboard = lazy(() => import("../../components/Modules/Dashboard/Dashboard"))
  //TOF
  const PublicDashboard = lazy(() =>
    import("../../components/home/PublicDashboard")
  );
  const User_Details = lazy(() =>
    import("../../components/Modules/TOF/UserDetail/User_Details")
  );
  const TMB = lazy(() => import("../../components/Modules/TOF/TMB"));
  const ApplicationReg = lazy(() =>
    import(
      "../../components/Modules/TOF/PlantationRegistration/PLRDashboard.js"
    )
  );
  const TreeFelling = lazy(() =>
    import("../../components/Modules/TOF/TreeFelling/TFLDashboard")
  );
  const PublicLogin = lazy(() => import("../../components/home/PublicLogin"));
  const BilingualSettings = lazy(() =>
    import(
      "../../components/Modules/AdminSettings/Dictionary/DictionaryDashboard"
    )
  );
  // const LookUpSettings = lazy(() =>
  //   import("../../components/Modules/AdminSettings/Lookup/LookUpSettings")
  // );
  const Applications = lazy(() =>
    import("../../components/Modules/TOF/Applications/Applications")
  );
  const StaffDashboard = lazy(() =>
    import("../../components/home/StaffDashboard")
  );
  const UserProfile = lazy(() =>
    import("../../components/Modules/Users/UserProfile")
  );
  const TOFDashboard = lazy(() =>
    import("../../components/Modules/TOF/TOFDashboard/TOFDashboard")
  );
  const ApplicationsTF = lazy(() =>
    import("../../components/Modules/TOF/ApplicationsTF/Dashboard")
  );
  const NewsDetails = lazy(() =>
    import("../../components/home/NewsDetails.js")
  );
  const EventDetails = lazy(() =>
    import("../../components/home/EventDetails.js")
  );
  //TOF

  //HRMS
  const HRMSDashboard = lazy(() =>
    import("../../components/Modules/HRMS/HRMSDashboard/HRMSDashboard")
  );

  const Wing = lazy(() =>
    import("../../components/Modules/HRMS/Wing/ManageWing")
  );
  const DEO_Dashboard = lazy(() =>
    import("../../components/Modules/HRMS/Approve_Employee/DEO_Dashboard")
  );
  const Employee = lazy(() =>
    import("../../components/Modules/HRMS/Employee/Employee")
  );
  const EmployeeDetails = lazy(() =>
    import("../../components/Modules/HRMS/Employee/EmployeeDetails")
  );
  const ApproveEmployee = lazy(() =>
    import(
      "../../components/Modules/HRMS/Approve_Employee/ApproveEmployeeDashboard"
    )
  );
  const ManageOffice = lazy(() =>
    import("../../components/Modules/HRMS/ManageOffice/ManageOffice")
  );
  const Transfer = lazy(() =>
    import("../../components/Modules/HRMS/Transfer/ManageTransfer")
  );
  const EmployeeSuspension = lazy(() =>
    import(
      "../../components/Modules/HRMS/EmployeeSuspension/EmployeeSuspension"
    )
  );
  const ListSeparation = lazy(() =>
    import("../../components/Modules/HRMS/EmployeeSeparation/ListSeparation")
  );

  const Leave_list = lazy(() =>
    import("../../components/Modules/HRMS/Leave/Leave_list")
  );
  const OrganizationalReport = lazy(() =>
    import("../../components/Modules/HRMS/OrganizationalReport/OrganizationalReport.js")
  );
  const DecimalDegreeConverter = lazy(() =>
    import("../../components/Modules/AdminSettings/Common/DecimalDegreeConverter.js")
  );
  const ListRecognitionAppreciation = lazy(() =>
    import("../../components/Modules/HRMS/RecognitionAppreciation/ListRecognitionAppreciation")
  );
  const Reports = lazy(() =>
    import("../../components/Modules/HRMS/Reports")
  );
  // const VideoCompressor = lazy(() =>
  //   import("../../components/Modules/AdminSettings/Common/VideoCompressor.js")
  // );
  // const Doc = lazy(() =>
  //   import("../../components/Modules/AdminSettings/Common/Doc.js")
  // );
  // const Pdf = lazy(() =>
  //   import("../../components/Modules/AdminSettings/Common/Pdf.js")
  // );
  //HRMS

  //Offence
  const Offence = lazy(() =>
    import("../Modules/Offence/OffenceList.js")
  );
  //offence

  const NurseryTarget = lazy(() =>
    import("../Modules/Nursery/NurseryTarget/Target")
  );

  //TRAINING
  const TrainingDashboard = lazy(() =>
    import("../../components/Modules/TRAINING/TrainingList/TrainingList")
  );
  const TrainingBatch = lazy(() =>
    import("../../components/Modules/TRAINING/TraningBatch/BatchList")
  );
  //TRAINING

  //VEHICLE MANAGEMENT

  const Vehicle = lazy(() =>
    import("../../components/Modules/VehicleManagement/Vehicle/Vehicle")
  );
  const VehicleAllotment = lazy(() =>
    import("../Modules/VehicleManagement/VehicleAllotment/VehicleAllotment")
  );
  const VehicleMaintainance = lazy(() =>
    import(
      "../Modules/VehicleManagement/VehicleMaintainance/VehicleMaintainance"
    )
  );
  //VEHICLE MANAGEMENT

  //Admin settings
  const UserRole_Mapping = lazy(() =>
    import(
      "../Modules/AdminSettings/UserManagement/UserRoleMapping/UserRole_Mapping"
    )
  );
  const AdminRoles = lazy(() =>
    import("../Modules/AdminSettings/AdminRoles/AdminRoles")
  );
  const User = lazy(() => import("../Modules/AdminSettings/User/User"));
  const Application = lazy(() =>
    import("../Modules/AdminSettings/Application/Application.js")
  );
  const UserRoleMatrix = lazy(() =>
    import(
      "../Modules/AdminSettings/UserManagement/RoleResponsbilityMatrix/RoleMatrix"
    )
  );
  const ClassifierSettings = lazy(() =>
    import("../Modules/AdminSettings/Classifier/ClassifierSettings")
  );
  const ExecuteQuery = lazy(() =>
    import("../Modules/AdminSettings/ExecuteQuery/ExecuteQuery")
  );

  //Admin settings

  const TrainingCalender = lazy(() =>
    import("../../components/Modules/TRAINING/TraningCalender/TrainingCalender")
  );
  const TrainingAssign = lazy(() =>
    import("../../components/Modules/TRAINING/AssignTraining/AssignTraining")
  );
  const ListFacilitators = lazy(() =>
    import("../../components/Modules/TRAINING/Facilitator/ListFacilitators")
  );
  const TrainingFeedback = lazy(() =>
    import("../../components/Modules/TRAINING/TraningFeedback/Training")
  );
  const TrainingSyllabus = lazy(() =>
    import("../../components/Modules/TRAINING/TrainingSyllabus/Syllabus")
  );
  const Unauthorized = lazy(() => import("../../components/routing/NoAccess."));
  const NotFound = lazy(() => import("../../components/routing/NotFound"));

  // //Layout testing
  // const Test1 = lazy(() => import("../../components/Modules/LayoutTesting/Test1"));
  // const Test2 = lazy(() => import("../../components/Modules/LayoutTesting/Test2"));
  // //Layout testing
  //FRA
  const FRAClaim = lazy(() => import("../../components/Modules/FRA/FRAClaim"));
  const FRAStatus = lazy(() =>
    import("../../components/Modules/FRA/FRAStatus/FRAStatus")
  );
  //Wildlife Management  
  const Dashboard = lazy(() => import("../Modules/WildlifeManagement/WildlifeDashboard/WildlifeDashboard.js"));


  const ListhumanwildConflict = lazy(() =>
    import(
      "../../components/Modules/WildlifeManagement/HumanWildlifeConflict/ListhumanwildConflict.js"
    )
  );
  const ListPayment = lazy(() =>
    import("../Modules/WildlifeManagement/HWCPayment/ListPayment.js")
  );
  const ListConflictDetails = lazy(() =>
    import(
      "../../components/Modules/WildlifeManagement/HWCompensetion/ListConflictDetails.js"
    )
  );

  const Census = lazy(() =>
    import("../Modules/WildlifeManagement/Census/CensusList.js")
  );
  const Poaching = lazy(() =>
    import("../Modules/WildlifeManagement/Poaching/PoachingList.js")
  );
  const Sighting = lazy(() =>
    import("../Modules/WildlifeManagement/Sighting/SightingList.js")
  );
  //BY SANDEEP
  const WorldLifePopulation = lazy(() =>
    import(
      "../Modules/WildlifeManagement/WildlifePopulation/WildlifePopulation.js"
    )
  );
  const WorldLifeMortality = lazy(() =>
    import(
      "../Modules/WildlifeManagement/WildlifeMortality/WildlifeMortality.js"
    )
  );
  const ListHuamanDeah = lazy(() =>
    import(
      "../../components/Modules/WildlifeManagement/HumanDeathAccident/ListHuamanDeah.js"
    )
  );

  //tof staff

  //Nursery
  const Nursery = lazy(() =>
    import("../../components/Modules/Nursery/NurseryInventory/Nursery")
  );
  const WorkProgress = lazy(() =>
    import("../Modules/Nursery/WorkProgress/WorkProgress")
  );
  // const Species = lazy(() => import("../../components/Modules/Nursery/Species"));
  const StockDetails = lazy(() =>
    import("../Modules/Nursery/StockDetails/StockDetails")
  );
  //Nursery
  const TOFDashboard_staff = lazy(() =>
    import("../../components/Modules/TOF/TOFDashboard/TOFDashboard_staff")
  );

  //Digital Library
  const DigitalLibrary = lazy(() =>
    import(
      "../../components/Modules/DigitalLibrary/DigitalLibrary/DigitalLibrary"
    )
  );

  const Contact = lazy(() =>
    import(
      "../../components/home/Contact"
    )
  );

  //Ecotourism
  const DestinationList = lazy(() =>
    import("../../components/Modules/Ecotourism/DestinationList.js")
  );
  //Ecotourism

  //Manuals
  const Manuals = lazy(() => import("../../components/home/Manuals"));
  //Manuals

  //Encroachment
  const RegisterEncroachment = lazy(() =>
    import(
      "../../components/Modules/Encroachment/RegisterEncroachment_Dashboad.js"
    )
  );
  const EncroachmentAdmin = lazy(() =>
    import(
      "../../components/Modules/Encroachment/EncrachmentAdmin/EncroachmentAdmin_List.js"
    )
  );
  //Encroachment

  //Rescue
  // const Rescue = lazy(() =>
  //   import("../../components/Modules/RESCUE/RescueList")
  // );
  // const RescueList_Incident = lazy(() =>
  //   import("../../components/Modules/WildlifeManagement/HumanWildlifeConflict/Rescue/RescueList_Incident.js")
  // );
  const Section11Dashboard = lazy(() =>
    import("../../components/Modules/WildlifeManagement/HumanWildlifeConflict/Section_11_Dashbord.js")
  );
  //Rescue end

  //AssetManagement
  const AssetManagement = lazy(() =>
    import("../../components/Modules/AssetManagement/AssetManagement_List")
  );
  //AssetManagement

  //Court case
  const CourtCase = lazy(() =>
    import("../../components/Modules/CourtCase/CourtCaseList")
  );

  //Court case end

  const PublicTOFInfo = lazy(() => import("../home/TOFInfo"));
  const DigitalDocument = lazy(() => import("../home/DigitalDocument"));
  const NurserySearch = lazy(() => import("../home/Nursery/NurserySearch"));
  const UserCompensation = lazy(() => import("../home/WLMS/UserCompensation"));
  const FMISPrivacyPolicy = lazy(() => import("../home/FMISPrivacyPolicy"));
  const FRAPrivacyPolicy = lazy(() => import("../home/FRAPrivacyPolicy"));
  const PatrollingPrivacyPolicy = lazy(() => import("../home/PatrollingPrivacyPolicy.js"));


  const ResetPassword = lazy(() => import("../home/ResetPassword"));

  // NewsSettings
  const ListNewsSetting = lazy(() => import("../Modules/AdminSettings/NewsSettings/ListNewsSetting.js"));
  // EventSettings
  const ListEventSetting = lazy(() => import("../Modules/AdminSettings/EventSetting/ListEvent.js"));

  //Protection and Patrolling
  const Alerts = lazy(() =>
    import("../../components/Modules/ProtectionPetrolling/Alerts/AlertList")
  );
  const AlertTransformation = lazy(() =>
    import("../../components/Modules/ProtectionPetrolling/AlertTransformation/AlertTransformationList")
  );

  const GFWETL = lazy(() =>
    import("../../components/Modules/ProtectionPetrolling/GFWETL/GFWProcess")
  );

  const PushAlert = lazy(() =>
    import("../../components/Modules/ProtectionPetrolling/PushAlert/PushAlertList")
  );
  const AlertObservation = lazy(() =>
    import("../../components/Modules/ProtectionPetrolling/AlertObservation/AlertObservationList")
  );

  const AlertObservationForm = lazy(() =>
    import("../../components/home/AlertObservationForm.js")
  );

  const AlertsReportForm = lazy(() =>
    import("../../components/Modules/ProtectionPetrolling/AlertsReport.js")
  );
  const IncidentSourceForm = lazy(() =>
    import("../home/IncidentSourceForm.js")
  );

  //Department Dashboard
  const DFODashboard = lazy(() => import("../Modules/DepartmentDashboard/DFODashboard/DFODashboard.js"));


  //Protection and Petrolling end

  const ConfidentialReport = lazy(() => import("../Modules/HRMS/Confidential_Report/Dashboard.js"));

  //AssetManagement
  const Revenue = lazy(() =>
    import("../../components/Modules/Revenue/Revenue_List")
  );
  //AssetManagement

  const Forest_Resource_Assessment = lazy(() => import("../../components/Modules/ForestResourceAssessment/ListForestResource.js"));
  const ListPlotData = lazy(() => import("../../components/Modules/ForestResourceAssessment/PlotData/ListPlotData.js"));

  const Patrol = lazy(() =>
    import("../../components/Modules/Patrolling/Patrol")
  );

  //Session Expired
  const SessionExpired = lazy(() => import("../../components/routing/SessionExpired.js"));
  //Session Expired
  return (
    <Routes>
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL} element={<Home />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/publicTOFInfo"} element={<PublicTOFInfo />} />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ResetPassword"} element={<ResetPassword />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Contact"} element={<Contact />} />


      {/* <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/BilingualSettings"}  "/Dashboard"
                element={
                    <AuthRoute requiredRoles={[String(Roles.DFO)]}>
                        <Dashboard />
                    </AuthRoute>
                } /> */}



      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicDashboard"}
        element={
          <AuthRoute
            requiredRoles={[
              String(Roles.DFO),
              String(Roles.Public),
              String(Roles.DEO),
            ]}
          >
            <PublicDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/User_Details"}
        element={
          <AuthRoute requiredRoles={[String(Roles.Public)]}>
            <User_Details />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TMB"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TMB />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationReg"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <ApplicationReg />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TreeFelling"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <TreeFelling />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicLogin"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PublicLogin />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <BilingualSettings />
          </AuthRoute>
        }
      />

      {/* <Route
        exact
        path="/LookUpSettings"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      /> */}
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRole_Mapping />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AdminRoles />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Application />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRoleMatrix"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRoleMatrix />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/User"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <User />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ClassifierSettings />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ExecuteQuery"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ExecuteQuery />
          </AuthRoute>
        }
      />

      {/* <Route
        exact
        path="/applicatntInfo"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      /> */}

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Applications"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Applications />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/StaffDashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <AppLogout>
              <StaffDashboard />
            </AppLogout>
          </AuthRoute>
        }
      />


      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserProfile"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserProfile />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsDetails/:newsId"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <NewsDetails />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventDetails/:eventid"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <EventDetails />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <TOFDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard_staff"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <TOFDashboard_staff />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/HRMS_Dashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <HRMSDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Employee"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <Employee />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApproveEmployee"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ApproveEmployee />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeDetails"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <EmployeeDetails />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeDetails/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <EmployeeDetails />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DEODashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DEO)]}>
            <DEO_Dashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageOffice"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ManageOffice />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Wing"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Wing />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageTransfer"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Transfer />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSuspension"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <EmployeeSuspension />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSeparation"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListSeparation />
          </AuthRoute>
        }
      />


      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Offence />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Training"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Nursery"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Nursery />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/WorkProgress"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <WorkProgress />
          </AuthRoute>
        }
      />
      {/* <Route exact path="/Species"
                element={
                    <AuthRoute requiredRoles={[String(Roles.DFO)]}>
                        <Species />
                    </AuthRoute>
                }
            /> */}
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/StockDetails"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <StockDetails />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Vehicle"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Vehicle />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleAllotment"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <VehicleAllotment />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleMaintainance"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <VehicleMaintainance />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingCalender"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingCalender />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Facilitators"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListFacilitators />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingAssign"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingAssign />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingFeedback"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingFeedback />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingSyllabus"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingSyllabus />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationsTF"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ApplicationsTF />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingBatch"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingBatch />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRA"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <FRAClaim />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRAStatus"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <FRAStatus />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeDashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Dashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Humanwildlifeconflict"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListhumanwildConflict />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Hwcpayment"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListPayment />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeCompensation"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListConflictDetails />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Census"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Census />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Poaching"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Poaching />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Sighting"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Sighting />
          </AuthRoute>
        }
      />
      {/* sandeep */}
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/wildlife-population"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <WorldLifePopulation />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalLibrary"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DigitalLibrary />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalDocument"} element={<DigitalDocument />} />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/wildlife-mortality"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <WorldLifeMortality />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DestinationList"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DestinationList />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Manuals"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Manuals />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/RegisterEncroachment"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <RegisterEncroachment />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EncroachmentAdmin"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <EncroachmentAdmin />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Section11Dashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Section11Dashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AssetManagement"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AssetManagement />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/CourtCase"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <CourtCase />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsSettings"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListNewsSetting />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventSettings"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListEventSetting />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Alerts"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Alerts />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Alerts/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Alerts />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertTransformation"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AlertTransformation />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <GFWETL />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PushAlert"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PushAlert />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservation"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AlertObservation />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservationForm"}
        element={
          // <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
          <AlertObservationForm />
          // </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertsReportForm"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AlertsReportForm />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/IncidentSourceForm"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <IncidentSourceForm />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DFODashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ConfidentialReport"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <ConfidentialReport />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Leave_list"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Leave_list />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Revenue"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Revenue />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/patrol"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Patrol />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ForestResourceAssessment"}
        element={
          <AuthRoute>
            <Forest_Resource_Assessment requiredRoles={[String(Roles.DFO)]} />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ListPlotData"}
        element={
          <AuthRoute>
            <ListPlotData requiredRoles={[String(Roles.DFO)]} />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/OrganizationalReport"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <OrganizationalReport />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DecimalDegreeConverter"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DecimalDegreeConverter />
          </AuthRoute>
        }
      />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FMISPrivacyPolicy"} element={<FMISPrivacyPolicy />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRAPrivacyPolicy"} element={<FRAPrivacyPolicy />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PatrollingPrivacyPolicy"} element={<PatrollingPrivacyPolicy />} />


      {/* <Route
        exact
        path="/VideoCompressor"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <VideoCompressor />
          </AuthRoute>
        }
      /> */}
      {/* <Route
        exact
        path="/Doc"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <Doc />
          </AuthRoute>
        }
      />
      <Route
        exact
        path="/Pdf"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <Pdf />
          </AuthRoute>
        }
      /> */}

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/as"} element={<Home />} />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ResetPassword/as"} element={<ResetPassword />} />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicDashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <PublicDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/User_Details/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.Public)]}>
            <User_Details />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TMB/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TMB />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationReg/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <ApplicationReg />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TreeFelling/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <TreeFelling />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicLogin/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PublicLogin />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <BilingualSettings />
          </AuthRoute>
        }
      />
      {/* <Route
        exact
        path="/LookUpSettings/as"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      /> */}
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRole_Mapping />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRoleMatrix/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRoleMatrix />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AdminRoles />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Application />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/User/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <User />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ClassifierSettings />
          </AuthRoute>
        }
      />

      {/* <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/applicatntInfo/as"}  
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      /> */}

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Applications/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Applications />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/StaffDashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <StaffDashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserProfile/as"}
        element={
          <AuthRoute>
            <UserProfile />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <TOFDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard_staff/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <TOFDashboard_staff />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleAllotment/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <VehicleAllotment />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleMaintainance/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <VehicleMaintainance />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/HRMS_Dashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <HRMSDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Employee/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <Employee />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApproveEmployee/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ApproveEmployee />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DEODashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DEO)]}>
            <DEO_Dashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageOffice/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ManageOffice />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Wing/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Wing />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageTransfer/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Transfer />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSuspension/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <EmployeeSuspension />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSeparation/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListSeparation />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Offence />
          </AuthRoute>
        }
      />


      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationsTF/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ApplicationsTF />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Facilitators/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListFacilitators />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Training/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingDashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Vehicle/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Vehicle />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Nursery/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Nursery />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/WorkProgress/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <WorkProgress />
          </AuthRoute>
        }
      />
      {/* <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/Species/as"}  
                element={
                    <AuthRoute requiredRoles={[String(Roles.DFO)]}>
                        <Species />
                    </AuthRoute>
                }
            /> */}
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/StockDetails/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <StockDetails />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingCalender/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingCalender />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingAssign/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingAssign />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingBatch/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingBatch />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingFeedback/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingFeedback />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingSyllabus/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <TrainingSyllabus />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRA/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <FRAClaim />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRAStatus/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <FRAStatus />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeDashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Dashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Humanwildlifeconflict/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListhumanwildConflict />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Hwcpayment/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListPayment />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeCompensation/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListConflictDetails />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Census/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Census />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Poaching/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Poaching />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Sighting/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Sighting />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/wild-life-population/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <WorldLifePopulation />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalLibrary/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DigitalLibrary />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalDocument/as"} element={<DigitalDocument />} />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/wildlife-mortality/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <WorldLifeMortality />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DestinationList/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DestinationList />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Manuals/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Manuals />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/RegisterEncroachment/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <RegisterEncroachment />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EncroachmentAdmin/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <EncroachmentAdmin />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Section11Dashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Section11Dashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AssetManagement/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AssetManagement />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/CourtCase/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <CourtCase />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsSettings/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListNewsSetting />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventSettings/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListEventSetting />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsDetails/as/:newsId"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <NewsDetails />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventDetails/as/:eventid"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <EventDetails />
          </AuthRoute>
        }
      />`
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertTransformation/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AlertTransformation />
          </AuthRoute>
        }
      />`
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <GFWETL />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PushAlert/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PushAlert />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservation/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AlertObservation />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservationForm/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <AlertObservationForm />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertsReportForm/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <AlertsReportForm />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/IncidentSourceForm/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <IncidentSourceForm />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DFODashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ConfidentialReport/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <ConfidentialReport />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Leave_list/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Leave_list />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Revenue/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Revenue />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/patrol/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Patrol />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ForestResourceAssessment/as"}
        element={
          <AuthRoute>
            <Forest_Resource_Assessment requiredRoles={[String(Roles.DFO)]} />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ListPlotData/as"}
        element={
          <AuthRoute>
            <ListPlotData requiredRoles={[String(Roles.DFO)]} />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/OrganizationalReport/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <OrganizationalReport />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/DecimalDegreeConverter/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <DecimalDegreeConverter />
          </AuthRoute>
        }
      />
      {/* <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/VideoCompressor/as"}  
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <VideoCompressor />
          </AuthRoute>
        }
      /> */}

      {/* <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/BilingualSettings"}  "/Doc/as"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Doc />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/BilingualSettings"}  "/Pdf/as"
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Pdf />
          </AuthRoute>
        }
      /> */}


      <Route path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/unauthorized"} element={<Unauthorized />} />
      <Route path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/*"} element={<NotFound />} />
      <Route path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/SessionExpired"} element={<SessionExpired />} />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FMISPrivacyPolicy/as"} element={<FMISPrivacyPolicy />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRAPrivacyPolicy/as"} element={<FRAPrivacyPolicy />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PatrollingPrivacyPolicy/as"} element={<PatrollingPrivacyPolicy />} />


      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/RecognitionAppreciation"}
        element={
          <AuthRoute>
            <ListRecognitionAppreciation requiredRoles={[String(Roles.DFO)]} />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Reports"}
        element={
          <AuthRoute>
            <Reports requiredRoles={[String(Roles.DFO)]} />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/RecognitionAppreciation/as"}
        element={
          <AuthRoute>
            <ListRecognitionAppreciation />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Reports/as"}
        element={
          <AuthRoute>
            <Reports />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurseryTarget"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <NurseryTarget />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurseryTarget/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <NurseryTarget />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurserySearch"} element={<NurserySearch />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurserySearch/as"} element={<NurserySearch />} />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserCompensation"} element={<UserCompensation />} />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserCompensation/as"} element={<UserCompensation />} />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/HuamanDeah"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListHuamanDeah />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/HuamanDeah/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListHuamanDeah />
          </AuthRoute>
        }
      />

    </Routes>
  );
};

export default Routes_En;
